<template>
  <div class="app" >
    <app-header fixed :style="bannerStyle">
        <b-navbar variant="faded" type="light" class="d-sm-down-none">
          <b-navbar-brand href="#">
            <img height="50" src="img/logo_amg_biru.png" alt="ERP ekossystem">
          </b-navbar-brand>
        </b-navbar>
      <b-navbar-nav class="ml-auto">
       <div class="title font-weight-bold"><b-link @click="selectCompany">{{user.company || 'please select company'}}</b-link></div>
        <b-tasknotif />
        <b-account @logout="logout" @profile="profile" @myapp="myapp" />
      </b-navbar-nav>
    </app-header>
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <div class="mb-4"></div>
          <router-view></router-view>
        </div>
      </main>
    </div>
    <b-modal v-model="lkuCompanyShow" size="lg" header-bg-variant="danger" :hide-footer="true" title="Switch Company" :centered="true">
        <lku-company @click="onSelectLkuCompany"></lku-company>
    </b-modal>        
  </div>
</template>

<style scoped>
  .header-dropdown {
    margin-right: 20px;
  }

</style>

<script>
import { Header as AppHeader } from "@coreui/vue";
import bAccount from "../components/account";
import bTasknotif from "../components/tasknotify";
import dim from "../apis/dimensionsample";
import lkuCompany from "../views/lookup/lkuCompanyuser"
import auth from "../apis/auth.js";

export default {
  components: { AppHeader, bAccount,bTasknotif, lkuCompany },
  data() {
    return { 
      user:{},
      bannerStyle:{},
      lkuCompanyShow:false };
  },
  computed: {
    compcode(){
      return this.$store.state.user.compcode;
    },
  },
  watch:{
    compcode: function(newval){
      if  (this.user.compcode != newval) {
        this.user = this.$store.state.user;
        // this.$forceUpdate();
        this.refreshCompany(this.user);
      }
    },
  },  
  sockets: {
        switchcompany: function (baru) {
            if  ((this.user.user_id === baru.user_id) && (this.user.compcode != baru.compcode)) {
              for (var key in baru) {
                  this.user[key] = baru[key];
              }
              this.refreshCompany(baru);
            }
        },
        task_changed: function (data) {
            if (data.compcode === this.$store.state.user.compcode) {
              this.$socket.emit('notificationupdate', {key:'notifycount', user : this.$store.state.user})
            }        
        },
  },  

  created: async function() {
    // const menus = await auth.menus("app");
    // this.menus = menus;
    const { $store } = this;

    if ($store.state.user) this.user = $store.state.user;
    this.user.company = this.user.company||'PT. Media Inisiatif';
    if (this.user){
      if (this.user.compcolor){
        // this.bannerStyle=`background-color: ${this.user.compcolor} !important;`;
        this.bannerStyle={backgroundColor: this.user.compcolor};
      }
    }
    try {
        const dims = await dim.dimsetup() ;
        $store.commit("dimension", dims);
    } catch (error) {
      console.log("error : ", error);
      // sementara dimatikan dulu, seharusnya di paksa login, jika hanya tokennya invalid, bukan karena semua jenis Error
      if (error.name== "TokenExpiredError") {
        window.localStorage.clear();
        this.$router.push({ name: "page.login" });
      }
    }
  },
  methods: {
    logout() {
      boogr.logout();
    },
    profile() {
      this.$router.push("/profile");
    },
    myapp() {
      location.href = process.env.VUE_APP_MYAPP;
    },
    selectCompany(){
      // console.log('selectCompany ke click di admin')
      this.lkuCompanyShow=true
    },
    onSelectLkuCompany: async function (_selected) {
      if (this.user.compcode != _selected.compcode) {
          this.user.compcode = _selected.compcode;
          this.user.company = _selected.company;
          this.user.compaddr= `${_selected.compaddr1} ${_selected.compaddr2 || ''} ${_selected.compaddr3 || ''}`;
          this.user.compwebsite= _selected.compwebsite;
          this.user.compcolor = _selected.compcolor;
          this.user.cashinflowNo = _selected.cashinflowNo;
          this.user.cashinflowNm = _selected.cashinflowNm;
          this.user.use_wfservice= _selected.use_wfservice;
          this.user.use_procure= _selected.use_procure;
          this.user.holding= _selected.holding;
          this.user.matauang= _selected.matauang;
              this.user.tglaktif= _selected.tglaktif;
              this.user.tglkoran= _selected.tglkoran;
              this.user.akhirbln= _selected.akhirbln;
              this.user.awalbln= _selected.awalbln;

          const baru ={}
          for (var key in this.user) {
              baru[key] = this.user[key]
          }      
          await auth.updateLastCompany(baru);
          this.refreshCompany(baru);
      }
      this.lkuCompanyShow=false;
    },
    refreshCompany: async function (baru) {
          this.$store.commit('user', baru);
          this.$socket.emit('notificationupdate', {key:'notifycount', user : baru});
          const dims = await dim.dimsetup() ;
          this.$store.commit("dimension", dims);
          this.bannerStyle={};
          if (this.user.compcolor){
            this.bannerStyle={backgroundColor: this.user.compcolor};
          }
          // window.location.reload();
          if (this.$route.name != 'app.modules') {
            // this.$router.push({ name: "app.modules" });
            this.$router.push("home");
            // router.push("home");
          }
    }
  },
};
</script>
